(function () {
  function initHub(root) {
    var content = root.querySelector('.luxe-hub__content');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('.luxe-hub__tile'));
    if (!content || !tiles.length) return;

    var cache = {};

    function extractGuide(htmlText) {
      var doc;
      try { doc = new DOMParser().parseFromString(htmlText, 'text/html'); }
      catch (e) { return null; }

      // Prefer the guide wrapper itself.
      var node = doc.querySelector('.luxe-guide-page');
      if (node) {
        // Remove the chapter's own closing CTA so it doesn't duplicate the hub's.
        var cta = node.querySelector('.luxe-cta');
        if (cta) cta.parentNode.removeChild(cta);
        return node.outerHTML;
      }

      // Fallback: the main page section wrapper Dawn uses.
      node = doc.querySelector('#MainContent .shopify-section')
          || doc.querySelector('main .shopify-section')
          || doc.querySelector('main');
      if (node) {
        var cta2 = node.querySelector('.luxe-cta');
        if (cta2) cta2.parentNode.removeChild(cta2);
        return node.innerHTML;
      }
      return null;
    }

    function setActive(tile) {
      tiles.forEach(function (t) {
        var on = (t === tile);
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    function render(id, html) {
      content.innerHTML = html;
      content.classList.remove('is-loading');
      var top = content.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function load(tile) {
      var id = tile.getAttribute('data-chapter');
      var pageUrl = tile.getAttribute('href');
      setActive(tile);
      content.classList.add('is-loading');

      if (cache[id]) { render(id, cache[id]); return; }

      fetch(pageUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (txt) {
          var guide = extractGuide(txt);
          if (!guide || guide.replace(/\s/g, '').length < 30) {
            content.innerHTML = '<div class="luxe-hub__empty">This chapter page has no Luxe Guide content yet, or it could not be read.<br>Page: ' + pageUrl + '</div>';
            content.classList.remove('is-loading');
            return;
          }
          cache[id] = guide;
          render(id, guide);
        })
        .catch(function (err) {
          content.innerHTML = '<div class="luxe-hub__empty">Could not load this chapter (' + (err && err.message ? err.message : 'error') + ').<br>Page: ' + pageUrl + '</div>';
          content.classList.remove('is-loading');
        });
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        e.preventDefault();
        load(tile);
      });
    });

    load(tiles[0]);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.luxe-hub'), initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
